<template lang="">
  <div>
    <Header
      title="Ferramentas de Url"
      subtitle="Área voltada para edição das UrlS"
    ></Header>

    <template>
      <v-tabs
        v-model="tab"
        color='black'
        class="d-flex justify-start"
      >
        <v-tab href="#encurtador" name="encurtador" class="mb-2">
          <img width="20" src="../../../../static/images/generator-url.svg"/>
          <span class="pl-3 ff">Encurtador de Url</span>
        </v-tab>
        <v-tab href="#editar" name="editar" class="mb-2">
          <img width="20" src="../../../../static/images/edit.svg"/>
          <span class="pl-3 ff">Editar Url</span>
        </v-tab>
        <v-tab href="#personalizar" name="personalizar" class="mb-2">
          <img width="20" src="../../../../static/images/custom.svg"/>
          <span class="pl-3 ff">Personalizar Url</span>
        </v-tab>
        <v-tab href="#magic-link" name="magic-link" class="mb-2">
          <img width="20" src="../../../../static/images/generator-url.svg"/>
          <span class="pl-3 ff">Magic Link</span>
        </v-tab>
        <v-tab href="#relatorios" name="relatorios" class="mb-2">
          <img width="20" src="../../../../static/images/search-black.svg"/>
          <span class="pl-3 ff">Relatórios</span>
        </v-tab>
      </v-tabs>

      <div v-if="tab === 'encurtador'">
        <ShortnerCreate />
      </div>
      <div v-if="tab === 'editar'">
        <ShortnerEdit />
      </div>
      <div v-if="tab === 'personalizar'">
        <ShortnerCustom />
      </div>    
      <div v-if="tab === 'magic-link'">
        <MagicLinkGenerator />
      </div>    
      <div v-if="tab === 'relatorios'">
        <ReportTools />
      </div>
    </template>

  </div>
</template>
<script>
// Components
import Header from '@/components/Header.vue'
import ShortnerCreate from '@/components/Contents/UrlTools/ShortnerCreate.vue'
import ShortnerEdit from '@/components/Contents/UrlTools/ShortnerEdit.vue'
import ShortnerCustom from '@/components/Contents/UrlTools/ShortnerCustom.vue'
import ReportTools from '@/components/Contents/UrlTools/ReportTools.vue'
import MagicLinkGenerator from '@/components/Contents/UrlTools/MagicLinkGenerator.vue'

export default {
  components: {
    Header,
    ShortnerCreate,
    ShortnerEdit,
    ShortnerCustom,
    ReportTools,
    MagicLinkGenerator,
  },
  data () {
    return {
      tab: 'encurtador',
    }
  },
}
</script>
<style lang="">
  .ff {
    text-transform: capitalize;
  }
</style>


// WEBPACK FOOTER //
// src/components/Contents/UrlTools/UrlTools.vue